<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="md:col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 text-gray-500 border-t border-b border-gray-300">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="form-input append"
            />
          </div>
        </template>
      </DatePicker>
      <driver-select v-model="filter.driverId" class="col-span-2" />
    </div>

    <template v-if="report">
      <div class="overflow-hidden card">
        <div class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
          Averages
        </div>
        <div class="grid grid-cols-4 border-t border-b divide-x">
          <div class="p-8">
            <div class="text-3xl font-bold">{{ calcDuration(report.data.average_time_to_accepted) }}</div>
            <div class="text-xs font-medium tracking-wider text-gray-500 uppercase">Average Time to Accept</div>
          </div>
          <div class="p-8">
            <div class="text-3xl font-bold">{{ calcDuration(report.data.average_time_to_started) }}</div>
            <div class="text-xs font-medium tracking-wider text-gray-500 uppercase">Average Time to Start</div>
          </div>
          <div class="p-8">
            <div class="text-3xl font-bold">{{ calcDuration(report.data.average_time_to_arrived) }}</div>
            <div class="text-xs font-medium tracking-wider text-gray-500 uppercase">Average Time to Arrive</div>
          </div>
          <div class="p-8">
            <div class="text-3xl font-bold">{{ calcDuration(report.data.average_time_to_completed) }}</div>
            <div class="text-xs font-medium tracking-wider text-gray-500 uppercase">Average Time to Complete</div>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div class="overflow-hidden border-b border-gray-100">
                <table class="min-w-full divide-y divide-gray-100">
                  <thead>
                    <tr>
                      <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                        Order No.
                      </th>
                      <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                        Accepted In
                      </th>
                      <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                        Started In
                      </th>
                      <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                        Arrived In
                      </th>
                      <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-400 uppercase bg-gray-50">
                        Completed In
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y">
                    <tr class="bg-white group" v-for="row in report.rows" :key="row.orderid">
                      <td class="px-6 py-4 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50">
                        {{ row.orderid }}
                      </td>
                      <td class="px-6 py-4 text-sm leading-5 whitespace-nowrap group-hover:bg-gray-50" :class="row.accepted_in ? 'text-gray-800' : 'text-gray-300'">
                        {{ row.accepted_in ? calcDuration(row.accepted_in) : '-' }}
                      </td>
                      <td class="px-6 py-4 text-sm leading-5 whitespace-nowrap group-hover:bg-gray-50" :class="row.started_in ? 'text-gray-800' : 'text-gray-300'">
                        {{ row.started_in ? calcDuration(row.started_in) : '-' }}
                      </td>
                      <td class="px-6 py-4 text-sm leading-5 whitespace-nowrap group-hover:bg-gray-50" :class="row.arrived_in ? 'text-gray-800' : 'text-gray-300'">
                        {{ row.arrived_in ? calcDuration(row.arrived_in) : '-' }}
                      </td>
                      <td class="px-6 py-4 text-sm leading-5 whitespace-nowrap group-hover:bg-gray-50" :class="row.completed_in ? 'text-gray-800' : 'text-gray-300'">
                        {{ row.completed_in ? calcDuration(row.completed_in) : '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { sub, formatDuration } from 'date-fns'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import DriverSelect from '@/components/DriverSelect'

export default {
  name: 'OrderLifecycleReport',

  components: {
    DatePicker,
    DriverSelect
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    params () {
      return { 
        filter: this.filter
      }
    }
  },

  data () {
    return {
      filter: {
        driverId: null,
        date: {
          start: sub(new Date(), { days: 30 }),
          end: new Date()
        }
      }
    }
  },

  methods: {
    calcDuration (seconds) {
      let min = (seconds / 60).toFixed()
      let sec = seconds % 60
      return `${min}m ${sec}s`
    }
  }
}
</script>